/**
 * العربية الفصحى الحديثة (MSA) — bundle initial.
 * Les clés absentes se replient sur l’anglais via i18next (`fallbackLng`).
 */
import { arEduflowDesignerExtras } from './i18n-ar-eduflow-designer-extras';

export const arTranslations: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'لوحة التحكم',
  'nav.projects': 'المشاريع',
  'nav.eduflow': 'EduFlow',
  'nav.audiobooks': 'الكتب الصوتية',
  'nav.audio_studio': 'الاستوديو الصوتي',
  'nav.store': 'المتجر',
  'nav.analytics': 'التحليلات',
  'nav.users': 'المستخدمون',
  'nav.settings': 'الإعدادات',
  'nav.profile': 'الملف الشخصي',
  'profile.institution': 'المؤسسة',
  'profile.institutionHint':
    'حسابك على LyrraStudio مرتبط بهذه المؤسسة. يدير المسؤول لديك هذا الربط.',
  'profile.institutionUnknownName': 'مؤسسة (الاسم غير متوفر)',
  'nav.notifications': 'الإشعارات',
  'nav.help': 'المساعدة',
  'common.close': 'إغلاق',

  'support.chat.title': 'دعم Lyrra',
  'support.chat.subtitle': 'اطرحوا سؤالكم: يردّ فريقنا هنا.',
  'support.chat.empty': 'اكتبوا رسالة لبدء المحادثة.',
  'support.chat.placeholder': 'رسالتكم…',
  'support.chat.send': 'إرسال',
  'support.chat.open': 'فتح دردشة الدعم',
  'support.chat.fromSupport': 'الدعم',
  'support.chat.fromYou': 'أنتم',
  'support.chat.identity.required':
    'يرجى إدخال الاسم الأول واسم العائلة والبريد الإلكتروني.',
  'support.chat.header.title': 'راسلونا',
  'support.chat.header.hint': 'نجيب عادةً خلال ١٢ ساعة عمل.',
  'support.chat.home.badge': 'نساعدكم',
  'support.chat.home.cardTitle': 'أسئلة حول Lyrra؟',
  'support.chat.home.cardBody':
    'يردّ فريقنا في «الرسائل»؛ المواضيع أدناه هي نفسها الموجودة في صفحة المساعدة.',
  'support.chat.help.title': 'نصائح سريعة',
  'support.chat.help.tip1':
    'صفوا المشكلة والصفحة (رابط أو لقطة شاشة). تفتح المواضيع نفس المساعدة الموجودة على /aide.',
  'support.chat.help.tip2': 'للزوار، نحتاج بريدكم الإلكتروني للمتابعة.',
  'support.chat.identity.title': 'قبل الدردشة، شاركوا بياناتكم:',
  'support.chat.identity.firstName': 'الاسم الأول',
  'support.chat.identity.lastName': 'اسم العائلة',
  'support.chat.identity.email': 'البريد الإلكتروني',
  'support.chat.identity.starting': 'جارٍ الفتح…',
  'support.chat.identity.submit': 'بدء المحادثة',
  'support.chat.nav.aria': 'التنقّل في أداة الدعم',
  'support.chat.nav.home': 'الرئيسية',
  'support.chat.nav.messages': 'الرسائل',
  'support.chat.nav.help': 'المساعدة',

  'admin.support.title': 'محادثات الدعم',
  'admin.support.loadError': 'تعذّر تحميل المحادثات.',
  'admin.support.replyError': 'تعذّر إرسال الرد.',
  'admin.support.selectThread': 'اختر محادثة لعرض الرسائل.',
  'admin.support.replyPlaceholder': 'ردكم للمستخدم…',
  'admin.support.sendReply': 'إرسال',
  'admin.support.refresh': 'تحديث',
  'admin.support.user': 'المستخدم',
  'admin.support.subject': 'الموضوع',
  'admin.support.status': 'الحالة',
  'admin.support.priority': 'الأولوية',
  'admin.support.updated': 'آخر تحديث',
  'admin.support.messages': 'خيط المحادثة',
  'admin.support.newestFirst': 'الأحدث في الأعلى',
  'admin.support.allStatuses': 'كل الحالات',

  'help.title': 'مركز المساعدة',
  'help.description': 'التوثيق والدعم',
  'help.searchPlaceholder': 'البحث عن موضوع…',
  'help.noResults': 'لا نتائج لهذا البحث.',
  'nav.community': 'المجتمع',
  'nav.library': 'المكتبة',
  'nav.certificates': 'الشهادات',
  'nav.institution': 'المؤسسة',
  'nav.groups': 'المجموعات',
  'nav.learners': 'المتعلمون',
  'nav.myLearning': 'تعلّمي',
  'nav.reports': 'التقارير',
  'nav.qualiopi': 'Qualiopi',
  'nav.training_plan': 'خطة التدريب',
  'nav.catalog': 'الكتالوج',
  'nav.competencies': 'الكفاءات',
  'nav.budget': 'الميزانية',
  'nav.campaigns': 'الحملات',
  'nav.codir': 'CODIR',
  'nav.home': 'الرئيسية',
  'nav.producerAssignments': 'مهام الإنتاج',
  'nav.videos': 'الفيديوهات',
  'nav.sounds': 'الأصوات',
  'nav.images': 'الصور',
  'pages.images.title': 'الصور',
  'pages.images.pasteHint': 'أو الصق لقطة شاشة (Ctrl+V / Cmd+V)',
  'pages.images.emptyHint':
    'اسحب وأفلِت، أو انقر للاستيراد، أو الصق لقطة شاشة (Ctrl+V / Cmd+V).',
  'pages.images.viewLarge': 'عرض بالحجم الكامل',
  'pages.images.lightboxTitle': 'معاينة الصورة',
  'pages.images.lightboxClose': 'إغلاق',
  'pages.images.lightboxBackdropClose': 'إغلاق المعاينة',
  'pages.images.lightboxPrev': 'الصورة السابقة',
  'pages.images.lightboxNext': 'الصورة التالية',
  'pages.images.cancel': 'إلغاء',
  'pages.images.changeFile': 'تغيير الملف',
  'pages.images.copyUrl': 'نسخ عنوان URL',
  'pages.images.count_one': '{{count}} صورة في مكتبتكم',
  'pages.images.count_other': '{{count}} صور في مكتبتكم',
  'pages.images.delete': 'حذف',
  'pages.images.deleteAction': 'حذف',
  'pages.images.deleteConfirmHint': 'سيُحذَف نهائيًا.',
  'pages.images.deleteTitle': 'حذف هذه الصورة؟',
  'pages.images.descriptionLabel': 'الوصف (اختياري)',
  'pages.images.descriptionPlaceholder': 'وصف موجز…',
  'pages.images.dropzoneBrowse': 'تصفّحوا',
  'pages.images.dropzoneFormats': 'PNG، JPG، WEBP، GIF',
  'pages.images.dropzoneLabel': 'أسقطوا صورة أو',
  'pages.images.fileSize.bytes': '{{size}} بايت',
  'pages.images.fileSize.kb': '{{size}} كيلوبايت',
  'pages.images.fileSize.mb': '{{size}} ميجابايت',
  'pages.images.fileSizeKb': '{{size}} كيلوبايت',
  'pages.images.importButton': 'استيراد',
  'pages.images.importSubtitle':
    'أضيفوا صورة إلى مكتبتكم لاستخدامها في تدريباتكم.',
  'pages.images.importTitle': 'استيراد صورة',
  'pages.images.noImages': 'لا صور مُستوردة',
  'pages.images.noResults': 'لا نتائج',
  'pages.images.searchPlaceholder': 'بحث عن صورة…',
  'pages.images.submit': 'استيراد',
  'pages.images.titleLabel': 'العنوان (اختياري)',
  'pages.images.titlePlaceholder': 'اسم الصورة…',
  'nav.documents': 'المستندات',
  'media.documents': 'المستندات',
  // صفحة /documents
  'documents.count_one': '{{count}} مستند',
  'documents.count_other': '{{count}} مستندات',
  'documents.delete.body': 'سيُزال المستند «{{filename}}» من مكتبتكم.',
  'documents.delete.cancel': 'إلغاء',
  'documents.delete.confirm': 'حذف',
  'documents.delete.irreversible': 'لا يمكن التراجع عن هذا الإجراء.',
  'documents.delete.title': 'حذف المستند؟',
  'documents.importPanel.cancel': 'إلغاء',
  'documents.importPanel.chooseFile': 'اختيار مستند PDF',
  'documents.importPanel.description':
    'سيُتاح المستند في كتل PDF وفي هذه المكتبة.',
  'documents.importPanel.descriptionLabel': 'الوصف',
  'documents.importPanel.descriptionPlaceholder': 'الوصف (اختياري)',
  'documents.importPanel.fileHint':
    'سيُتاح المستند في كتلة PDF وفي هذه المكتبة.',
  'documents.importPanel.submit': 'استيراد',
  'documents.importPanel.title': 'استيراد PDF',
  'documents.importPanel.titleLabel': 'العنوان',
  'documents.importPanel.titlePlaceholder': 'عنوان المستند',
  'documents.importPanel.uploading': 'جارٍ الرفع',
  'documents.importPdf': 'استيراد PDF',
  'documents.loading': 'جارٍ تحميل المكتبة…',
  'documents.newDocument': 'مستند جديد',
  'documents.noDocuments': 'لا مستندات',
  'documents.noDocumentsHint':
    'استوردوا ملفات PDF هنا لإعادة استخدامها لاحقًا في كتلة PDF.',
  'documents.noResults': 'لا يوجد مستند يطابق بحثكم.',
  'documents.pages_one': '{{count}} صفحة',
  'documents.pages_other': '{{count}} صفحات',
  'documents.previewTitle': 'معاينة المستند',
  'documents.searchPlaceholder': 'بحث عن PDF…',
  'documents.share.accessRemoved': 'تم سحب الوصول عن المتعلّم.',
  'documents.share.assignedTitle': 'متعلّمون لديهم إمكانية الوصول',
  'documents.share.close': 'إغلاق',
  'documents.share.createAndShare': 'إنشاء ومشاركة وإرسال الدعوة',
  'documents.share.createError': 'تعذّر إنشاء المتعلّم.',
  'documents.share.createLearner': 'إنشاء متعلّم جديد',
  'documents.share.createdSuccess': 'تم إنشاء/ربط الحساب ومشاركة المستند وإرسال البريد.',
  'documents.share.creating': 'جارٍ الإرسال…',
  'documents.share.emailPlaceholder': 'البريد الإلكتروني *',
  'documents.share.firstNamePlaceholder': 'الاسم الأول *',
  'documents.share.hideCreateLearner': 'إخفاء الإنشاء السريع',
  'documents.share.lastNamePlaceholder': 'اسم العائلة *',
  'documents.share.loadingAssigned': 'جارٍ التحميل…',
  'documents.share.loadingLearners': 'جارٍ تحميل المتعلّمين…',
  'documents.share.noAssigned': 'لا متعلّم مُعيَّن لهذا المستند.',
  'documents.share.noLearners': 'لا متعلّمون متاحون.',
  'documents.share.removeButton': 'سحب',
  'documents.share.removeError': 'تعذّر سحب الوصول.',
  'documents.share.searchPlaceholder': 'بحث عن متعلّم (اسم، بريد)',
  'documents.share.selectLearner': 'اختيار متعلّم قائم',
  'documents.share.shareButton': 'مشاركة',
  'documents.share.shareError': 'تعذّر مشاركة المستند.',
  'documents.share.sharedSuccess': 'تمت مشاركة المستند وإرسال الدعوة.',
  'documents.share.title': 'مشاركة المستند',
  'documents.subtitle': 'مكتبة مستندات PDF قابلة لإعادة الاستخدام في المُصمِّم.',
  'documents.title': 'المستندات',
  'documents.toast.importError': 'استيراد غير ممكن',
  'documents.toast.importErrorDefault': 'فشل الاستيراد.',
  'documents.toast.importSuccess': 'تم استيراد المستند',
  'documents.toast.importSuccessDesc': 'أُضيف {{filename}} إلى مكتبة المستندات.',
  'documents.updating': 'جارٍ التحديث…',
  'nav.podcasts': 'البودكاست',
  'nav.webinars': 'الندوات عبر الإنترنت',
  'nav.webinarsEnterprise': 'الندوات عبر الإنترنت (المؤسسة)',
  'webinar.room.capacityFull':
    'بلغت هذه القاعة الحد الأقصى للسعة ({{max}} مشارك في الوقت نفسه). يرجى المحاولة لاحقًا.',
  'webinar.room.participants': 'المشاركون',
  'webinar.room.chat': 'الدردشة',
  'webinar.room.sidePanelTabs': 'المشاركون والدردشة',
  'webinar.room.you': 'أنت',
  'webinar.room.showParticipantsPanel': 'إظهار لوحة المشاركين',
  'webinar.room.hideParticipantsPanel': 'طي اللوحة',
  'webinar.room.publicGateTitle': 'الدخول إلى الندوة',
  'webinar.room.publicGateHint':
    'أمّن المنظّم هذه القاعة. أدخلوا المعرّف وكلمة المرور الواردين في نموذج التسجيل العام أو في رسالة الدعوة.',
  'webinar.room.publicGateLogin': 'المعرّف',
  'webinar.room.publicGatePassword': 'كلمة المرور',
  'webinar.room.publicGateSubmit': 'دخول القاعة',
  'webinar.room.publicGateSubmitting': 'جارٍ التحقق…',
  'webinar.room.publicGateDenied': 'معرّف أو كلمة مرور غير صحيحة.',
  'webinar.room.socketGateDenied':
    'تعذّر الانضمام المباشر إلى القاعة: بيانات الوصول العامة مفقودة أو منتهية الصلاحية. أعِد تحميل الصفحة وأدخلوا المعرّف وكلمة المرور من جديد.',
  // صفحة /webinars للمُنشّط
  'webinars.card.code': 'الرمز {{code}}',
  'webinars.card.copyLink': 'نسخ الرابط',
  'webinars.card.delete': 'حذف',
  'webinars.card.edit': 'تعديل',
  'webinars.card.openRoom': 'فتح القاعة',
  'webinars.card.publicSignupBadge': 'تسجيل عام',
  'webinars.deleteDialog.body': 'حذف «{{title}}»؟ لا يمكن التراجع عن هذا الإجراء.',
  'webinars.deleteDialog.cancel': 'إلغاء',
  'webinars.deleteDialog.confirm': 'حذف',
  'webinars.deleteDialog.title': 'حذف ندوة عبر الإنترنت',
  'webinars.eligibility.default':
    'الندوات عبر الإنترنت غير متاحة لهذا الحساب (تحقّقوا من الاتصال بواجهة البرمجة أو تواصلوا مع المسؤول).',
  'webinars.eligibility.moduleDisabled':
    'لم تُفعّل بعد وحدة الندوات عبر الإنترنت لمؤسستكم. يجب على مسؤول تفعيل «تفعيل الندوات» من المسار مؤسسة ← الندوات.',
  'webinars.eligibility.noInstitution': 'لا توجد مؤسسة مرتبطة بحسابكم.',
  'webinars.eligibility.notAuthorized':
    'حسابكم غير مدرج في قائمة المُقدّمين المصرّح لهم. اطلبوا من المؤسسة إضافتكم (إدارة الندوات ← مُقدّمون مُصرَّح لهم).',
  'webinars.eligibility.roleNotAllowed': 'دوركم لا يسمح بإدارة الندوات عبر الإنترنت بهذا الحساب.',
  'webinars.empty.createFirst': 'إنشاء ندوة',
  'webinars.empty.noResults': 'لا نتائج',
  'webinars.empty.noResultsHint': 'غيّرو معايير البحث.',
  'webinars.empty.noWebinarsHint': 'أنشئوا قاعة وادعوا المشاركين من اللوحة الجانبية.',
  'webinars.empty.noWebinarsYet': 'لا توجد ندوات حتى الآن',
  'webinars.externalInvite.closeButton': 'إغلاق',
  'webinars.externalInvite.description':
    'أشخاص غير مدرجين في قائمة المتعلّمين: يتلقّى كل بريد رسالة تحتوي على رابط القاعة ومرفق تقويم.',
  'webinars.externalInvite.done': 'تم.',
  'webinars.externalInvite.duplicatesCount_one': '{{count}} مُدعو مسبقًا',
  'webinars.externalInvite.duplicatesCount_other': '{{count}} مُدعوين مسبقًا',
  'webinars.externalInvite.emailsHint':
    'عنوان واحد في كل سطر، أو مفصول بفواصل. تُهمَل المكرّرات والدعوات المُرسَلة مسبقًا.',
  'webinars.externalInvite.emailsLabel': 'عناوين البريد الإلكتروني',
  'webinars.externalInvite.emailsPlaceholder': 'someone@example.com\nother@example.org',
  'webinars.externalInvite.errorMax200': 'حد أقصى 200 عنوانًا في كل إرسال.',
  'webinars.externalInvite.errorMinOne': 'أدخلوا عنوان بريد إلكتروني صالحًا واحدًا على الأقل.',
  'webinars.externalInvite.errorsLabel': 'أخطاء: {{errors}}',
  'webinars.externalInvite.sendButton': 'إرسال الدعوات',
  'webinars.externalInvite.sendFailed': 'فشل الإرسال',
  'webinars.externalInvite.sentCount_one': 'بريد {{count}} مُرسَل',
  'webinars.externalInvite.sentCount_other': '{{count}} رسائل بريد مُرسَلة',
  'webinars.externalInvite.skippedCount_one': '{{count}} مُتجاهَل',
  'webinars.externalInvite.skippedCount_other': '{{count}} مُتجاهَلة',
  'webinars.externalInvite.title': 'دعوات عبر البريد',
  'webinars.invite.duplicatesCount_one': '{{count}} مُدعو مسبقًا',
  'webinars.invite.duplicatesCount_other': '{{count}} مُدعوين مسبقًا',
  'webinars.invite.errorsLabel': 'أخطاء: {{errors}}',
  'webinars.invite.externalButton': 'خارج القائمة (بريد)',
  'webinars.invite.failed': 'فشل',
  'webinars.invite.groupSuccess': 'عُولجت دعوات المجموعة (أُرسِل بريد للأعضاء).',
  'webinars.invite.inviteButton': 'دعوة',
  'webinars.invite.learnersHelp':
    'ابحثوا عن متعلّم في مؤسستكم: يُرسَل <strong>بريد دعوة</strong> (رابط + تقويم) مع كل دعوة.',
  'webinars.invite.learnersTitle': 'المتعلّمون',
  'webinars.invite.noCandidates':
    'لا متعلّمين للعرض (جرّبوا بحثًا آخر أو «خارج القائمة» لعناوين خارجية).',
  'webinars.invite.noInvitations': 'لا دعوات مُسجَّلة.',
  'webinars.invite.searchLabel': 'بحث عن متعلّم',
  'webinars.invite.searchPlaceholder': 'الاسم أو البريد…',
  'webinars.invite.searching': 'جارٍ البحث…',
  'webinars.invite.sentCount_one': 'دعوة {{count}} مُرسَلة (بريد)',
  'webinars.invite.sentCount_other': '{{count}} دعوات مُرسَلة (بريد)',
  'webinars.invite.sentInvitationsToggle': 'الدعوات المُرسَلة',
  'webinars.page.newButton': 'ندوة جديدة',
  'webinars.page.searchPlaceholder': 'بحث…',
  'webinars.page.subtitle':
    'قائمة قاعاتكم — افتحوا اللوحة لإنشاء ندوة أو تعديلها أو دعوة المشاركين.',
  'webinars.page.title': 'الندوات عبر الإنترنت',
  'webinars.panel.backgroundHint':
    'صورة خلف المحتوى المُشارَك للمشاركين: أدخلوا عنوان URL (https أو http)، أو ارفعوا ملفًا (يُحفَظ في «صوري»)، أو اختاروا صورة مُسبقة. اتركوا الحقل فارغًا للخلفية الافتراضية لـ Lyrra.',
  'webinars.panel.backgroundLabel': 'صورة الخلفية (عرض المشارك)',
  'webinars.panel.backgroundPlaceholder': 'https://… أو مسار صوري',
  'webinars.panel.backgroundUrlLabel': 'عنوان الصورة (URL)',
  'webinars.panel.backgroundUploadTitle': 'رفع صورة (صوري)',
  'webinars.panel.backgroundLibraryTitle': 'صوري',
  'webinars.panel.backgroundLibraryEmpty':
    'لا توجد صور بعد — ارفعوا من الأعلى أو من صفحة الصور في لوحة التحكم.',
  'webinars.panel.backgroundOpenImagesPage': 'فتح صفحة الصور',
  'webinars.panel.backgroundUseDefault': 'استخدام خلفية Lyrra الافتراضية',
  'webinars.panel.backgroundUploading': 'جارٍ الرفع…',
  'webinars.panel.backgroundUploadError': 'فشل رفع الصورة.',
  'webinars.panel.copyLink': 'نسخ الرابط',
  'webinars.panel.createButton': 'إنشاء',
  'webinars.panel.createDescription':
    'أكملوا المعلومات ثم احفظوا. يمكنكم دعوة المشاركين لاحقًا.',
  'webinars.panel.createTitle': 'ندوة جديدة',
  'webinars.panel.dateLabel': 'اليوم (اختياري)',
  'webinars.panel.deleteButton': 'حذف',
  'webinars.panel.descriptionLabel': 'الوصف',
  'webinars.panel.durationError':
    'أدخلوا المدة بصيغة ساعات:دقائق (مثل 1:00 أو 0:45).',
  'webinars.panel.durationHint':
    'إلزامي إذا أُدخل يوم. مثل 1:30 لساعة ونصف، 0:45 لـ ٤٥ دقيقة.',
  'webinars.panel.durationLabel': 'المدة (س:د)',
  'webinars.panel.editTitle': 'ندوة عبر الإنترنت',
  'webinars.panel.loading': 'جارٍ التحميل…',
  'webinars.panel.openRoom': 'فتح القاعة',
  'webinars.panel.presentersLabel': 'مُقدّمون مُشتركون',
  'webinars.panel.roomCode': 'رمز القاعة:',
  'webinars.panel.timeHint': 'إن وُضع فارغًا: 9:00.',
  'webinars.panel.timeLabel': 'وقت البدء',
  'webinars.panel.titleLabel': 'العنوان',
  'webinars.panel.waitingHtmlLabel': 'HTML غرفة الانتظار (اختياري)',
  'webinars.panel.waitingHtmlPlaceholder': '<p>مرحبًا…</p>',
  'webinars.panel.publicAccessTitle': 'تسجيل عام (معرّف + كلمة مرور)',
  'webinars.panel.publicAccessHelp':
    'عند التفعيل، يرى المشاركون غير المُقدّمين المُشتركين نموذجًا بعد تسجيل الدخول إلى Lyrra: يجب أن يُدخلوا المعرّف وكلمة المرور اللذين تُعرّفهما هنا لدخول القاعة.',
  'webinars.panel.publicAccessLoginLabel': 'معرّف نموذج التسجيل',
  'webinars.panel.publicAccessPasswordLabel': 'كلمة مرور النموذج',
  'webinars.panel.publicAccessPasswordPlaceholderNew': '8 أحرف على الأقل',
  'webinars.panel.publicAccessPasswordPlaceholderKeep': 'اترك الحقل فارغًا للإبقاء على كلمة المرور الحالية',
  'webinars.panel.publicAccessPasswordHint':
    'عند الإنشاء أو أول تفعيل: كلمة المرور إلزامية (8 كحد أدنى). لاحقًا: اترك الحقل فارغًا لعدم تغييرها.',
  'webinars.panel.publicAccessLoginRequired': 'أدخلوا معرّفًا للتسجيل العام.',
  'webinars.panel.publicAccessPasswordRequired': 'عيّنوا كلمة مرور مكوّنة من 8 أحرف على الأقل.',
  'webinars.panel.publicAccessPasswordMin': 'يجب أن تتكوّن كلمة المرور العامة من 8 أحرف على الأقل.',
  'webinars.status.draft': 'مسودّة',
  'webinars.status.ended': 'انتهى',
  'webinars.status.live': 'مباشر',
  'webinars.status.scheduled': 'مجدول',
  // صفحة /videos
  'videos.addPanel.cancel': 'إلغاء',
  'videos.addPanel.continue': 'متابعة',
  'videos.addPanel.description':
    'استوردوا ملفات MP4 أو WebM أو MOV لاستخدامها في دوراتكم التدريبية.',
  'videos.addPanel.dropzoneFormats': 'MP4، WebM، MOV',
  'videos.addPanel.dropzoneLabel': 'انقر لاختيار فيديو',
  'videos.addPanel.title': 'إضافة فيديو',
  'videos.addPanel.titleLabel': 'العنوان',
  'videos.addPanel.titlePlaceholder': 'عنوان الفيديو…',
  'videos.card.delete': 'حذف',
  'videos.card.edit': 'تعديل',
  'videos.card.noThumbnail': 'لا صورة مصغّرة',
  'videos.deleteDialog.body': 'سيتم حذف «{{title}}» نهائيًا.',
  'videos.deleteDialog.cancel': 'إلغاء',
  'videos.deleteDialog.confirm': 'حذف',
  'videos.deleteDialog.title': 'حذف الفيديو؟',
  'videos.empty.addButton': 'إضافة فيديو',
  'videos.empty.description':
    'استوردوا أول فيديو لإدارته واستخدامه في تدريباتكم.',
  'videos.empty.title': 'لا فيديوهات',
  'videos.page.addButton': 'إضافة فيديو',
  'videos.page.count_one': 'فيديو {{count}} في مكتبتكم',
  'videos.page.count_other': '{{count}} فيديو في مكتبتكم',
  'videos.page.title': 'الفيديوهات',
  'videos.preview.noFile': 'لا يوجد ملف متاح.',
  'videos.status.draft': 'مسودّة',
  'videos.status.published': 'منشور',
  // صفحة /sounds
  'sounds.card.delete': 'حذف',
  'sounds.card.mute': 'كتم الصوت',
  'sounds.deleteDialog.body':
    'سيتم حذف «{{title}}» نهائيًا من الخادم ومكتبتكم.',
  'sounds.deleteDialog.cancel': 'إلغاء',
  'sounds.deleteDialog.confirm': 'حذف',
  'sounds.deleteDialog.title': 'حذف هذا الصوت؟',
  'sounds.empty.description':
    'استوردوا ملفاتكم: تُخزَّن في قاعدة البيانات وتُنسَخ إلى الخادم حتى لا يضيع شيء.',
  'sounds.empty.importButton': 'استيراد صوت',
  'sounds.empty.title': 'لا أصوات مُستوردة',
  'sounds.fileSize.bytes': '{{size}} بايت',
  'sounds.fileSize.kb': '{{size}} كيلوبايت',
  'sounds.fileSize.mb': '{{size}} ميجابايت',
  'sounds.importPanel.cancel': 'إلغاء',
  'sounds.importPanel.changeFile': 'تغيير الملف',
  'sounds.importPanel.createTag': 'إنشاء «{{tag}}»',
  'sounds.importPanel.description':
    'أضيفوا ملفًا صوتيًا إلى مكتبتكم لمساراتكم التعليمية.',
  'sounds.importPanel.descriptionLabel': 'الوصف',
  'sounds.importPanel.descriptionPlaceholder': 'صفوا هذا الصوت…',
  'sounds.importPanel.dropzoneBrowse': 'تصفّحوا',
  'sounds.importPanel.dropzoneFormats': 'MP3، WAV، OGG، M4A، AAC، FLAC',
  'sounds.importPanel.dropzoneLabel': 'أسقطوا ملفًا صوتيًا أو',
  'sounds.importPanel.optional': '(اختياري)',
  'sounds.importPanel.submit': 'استيراد',
  'sounds.importPanel.submitting': 'جارٍ الإرسال…',
  'sounds.importPanel.tagsHint':
    'اكتبوا ثم اضغطوا Enter · تُنشأ الوسوم الجديدة تلقائيًا',
  'sounds.importPanel.tagsLabel': 'وسوم',
  'sounds.importPanel.tagsPlaceholder': 'إضافة وسوم…',
  'sounds.importPanel.title': 'استيراد صوت',
  'sounds.importPanel.titleLabel': 'العنوان',
  'sounds.importPanel.titlePlaceholder': 'اسم الصوت…',
  'sounds.importPanel.titleRequired': 'العنوان إلزامي',
  'sounds.noResults': 'لا يوجد صوت يطابق «{{query}}»',
  'sounds.page.count_one':
    '{{count}} ملف — محفوظ في قاعدة البيانات وعلى الخادم',
  'sounds.page.count_other':
    '{{count}} ملفات — محفوظة في قاعدة البيانات وعلى الخادم',
  'sounds.page.importButton': 'استيراد',
  'sounds.page.searchPlaceholder': 'عنوان، وصف، وسم…',
  'sounds.page.title': 'الأصوات',
  'nav.parcours': 'المسارات التعليمية',
  'nav.eduflowList': 'الدورات',
  'nav.section.pilotage': 'الإدارة',
  'nav.section.creation': 'الإنشاء',
  'nav.section.medias': 'الوسائط',
  'nav.section.aide': 'المساعدة',
  'sidebar.brandTagline': 'التدريب',
  'sidebar.logoInstitutionAlt': 'شعار المؤسسة',
  'sidebar.expand': 'توسيع القائمة',
  'sidebar.collapse': 'طي القائمة',
  'sidebar.expandAria': 'توسيع الشريط الجانبي',
  'sidebar.collapseAria': 'طي الشريط الجانبي',
  'header.toggleMenu': 'فتح أو إغلاق القائمة',
  'header.search': 'بحث…',
  'header.toggleTheme': 'تبديل الوضع الفاتح أو الداكن',
  'header.profile': 'الملف الشخصي',
  'header.settings': 'الإعدادات',
  'header.logout': 'تسجيل الخروج',
  'header.language': 'اللغة',
  // Centre de lecture adaptée (A11yToolbar — pages publiques et app)
  'accessibility.openCenter': 'فتح مركز إتاحة الوصول',
  'accessibility.center': 'إتاحة الوصول',
  'accessibility.modalTitle': 'مركز القراءة المُكيَّفة',
  'accessibility.modalDescription':
    'اضبط الواجهة لضعف البصر وعُسر القراءة ولراحة أفضل عند القراءة.',
  'accessibility.closeCenter': 'إغلاق مركز إتاحة الوصول',
  'accessibility.accessPad.connected': 'تم توصيل Lyrra Access Pad',
  'accessibility.accessPad.playGuide': 'تشغيل دليل LyrraPad',
  'accessibility.accessPad.pauseGuide': 'إيقاف دليل LyrraPad مؤقتًا',
  'accessibility.presets': 'ملفات تعريف جاهزة',
  'accessibility.preset.standard.label': 'عادي',
  'accessibility.preset.standard.desc': 'عرض التطبيق الافتراضي.',
  'accessibility.preset.lowVision.label': 'ضعف البصر',
  'accessibility.preset.lowVision.desc': 'تباين أعلى، نص أكبر، وإشارات بصرية أوضح.',
  'accessibility.preset.dys.label': 'عُسر القراءة',
  'accessibility.preset.dys.desc': 'قراءة أسهل مع مسافات أوفر وخط أوضح.',
  'accessibility.typography': 'إعدادات الخط',
  'accessibility.fontScale': 'حجم النص',
  'accessibility.lineHeight': 'تباعد الأسطر',
  'accessibility.letterSpacing': 'تباعد الحروف',
  'accessibility.wordSpacing': 'تباعد الكلمات',
  'accessibility.visualAids': 'مساعدات بصرية',
  'accessibility.highContrast': 'تباين عالٍ',
  'accessibility.highContrastDesc': 'يعزّز تباين القراءة والحدود والإشارات البصرية.',
  'accessibility.underlineLinks': 'روابط مسطّرة',
  'accessibility.underlineLinksDesc': 'يجعل الروابط والمناطق التفاعلية أوضح.',
  'accessibility.dyslexiaFont': 'خط قراءة مُيسَّر',
  'accessibility.dyslexiaFontDesc':
    'يستخدم خطًا أكثر راحة لذوي عُسر القراءة والقرّاء المتعبين.',
  'accessibility.reducedMotion': 'حركة مخفّفة',
  'accessibility.reducedMotionDesc':
    'يقلّل الحركات والانتقالات لتخفيف الإزعاج البصري.',
  'accessibility.mouseMagnifier': 'عدسة مكبّرة للقراءة',
  'accessibility.mouseMagnifierDesc':
    'تعرض عدسة دائرية تتبع المؤشر وتُكبّر محتوى المسار تحت المنطقة المُشار إليها (عرض مُكبّر للقراءة فقط).',
  'accessibility.alwaysOn': 'تحسينات دائمة التفعيل',
  'accessibility.alwaysOnFocus': 'تركيز لوحة المفاتيح أوضح',
  'accessibility.alwaysOnLinks': 'روابط وعناصر تفاعلية أسهل للكشف',
  'accessibility.alwaysOnSaved': 'تُحفظ الإعدادات تلقائيًا على هذا الجهاز',
  'accessibility.navigation': 'التنقّل',
  'accessibility.keyboardNavigation': 'التنقّل بلوحة المفاتيح',
  'accessibility.keyboardNavigationDesc':
    'استخدم مفاتيح السهم يسار/أعلى للكتلة السابقة ويمين/أسفل للكتلة التالية (مثل الأزرار السفلية).',
  'accessibility.simplifiedTextMode': 'وضع تبسيط النص',
  'accessibility.simplifiedTextModeDesc':
    'يُبسّط نصوص المسار فقط لتسهيل القراءة والفهم.',
  'accessibility.imageHoverAudio':
    'وضع ضعف البصر: تشغيل صوت وصف الصورة عند التمرير',
  'accessibility.imageHoverAudioDesc':
    'عند المرور فوق الصورة داخل المشغّل، يبدأ الوصف الصوتي تلقائيًا.',
  'btn.save': 'حفظ',
  'btn.cancel': 'إلغاء',
  'btn.delete': 'حذف',
  'btn.edit': 'تعديل',
  'btn.create': 'إنشاء',
  'btn.add': 'إضافة',
  'btn.close': 'إغلاق',
  'btn.confirm': 'تأكيد',
  'btn.back': 'رجوع',
  'btn.next': 'التالي',
  'btn.previous': 'السابق',
  'btn.submit': 'إرسال',
  'btn.search': 'بحث',
  'btn.filter': 'تصفية',
  'btn.export': 'تصدير',
  'btn.import': 'استيراد',
  'btn.download': 'تنزيل',
  'btn.upload': 'رفع',
  'btn.refresh': 'تحديث',
  'btn.retry': 'إعادة المحاولة',
  'btn.view': 'عرض',
  'btn.details': 'التفاصيل',
  'btn.publish': 'نشر',
  'btn.unpublish': 'إلغاء النشر',
  'btn.duplicate': 'نسخ',
  'btn.archive': 'أرشفة',
  'btn.restore': 'استعادة',
  'btn.send': 'إرسال',
  'btn.apply': 'تطبيق',
  'btn.reset': 'إعادة تعيين',
  'btn.select_all': 'تحديد الكل',
  'btn.deselect_all': 'إلغاء التحديد',
  'btn.load_more': 'تحميل المزيد',
  'btn.show_more': 'عرض المزيد',
  'btn.show_less': 'عرض أقل',
  'btn.copy': 'نسخ',
  'btn.share': 'مشاركة',
  'btn.preview': 'معاينة',
  'btn.continue': 'متابعة',
  'btn.skip': 'تخطٍ',
  'common.loading': 'جارٍ التحميل...',
  'common.refresh': 'تحديث',
  'common.saving': 'جارٍ الحفظ...',
  'common.saved': 'تم الحفظ',
  'common.error': 'خطأ',
  'common.success': 'تم بنجاح',
  'common.warning': 'تنبيه',
  'common.info': 'معلومات',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.or': 'أو',
  'common.and': 'و',
  'common.all': 'الكل',
  'common.none': 'لا شيء',
  'common.total': 'الإجمالي',
  'common.actions': 'إجراءات',
  'common.created_at': 'تاريخ الإنشاء',
  'common.updated_at': 'تاريخ التعديل',
  'common.sort_by': 'ترتيب حسب',
  'common.per_page': 'في الصفحة',
  'common.page': 'صفحة',
  'common.of': 'من',
  'common.results': '{{count}} نتيجة',
  'common.no_data': 'لا توجد بيانات',
  'common.coming_soon': 'قريبًا',
  'common.beta': 'إصدار تجريبي',
  'common.new': 'جديد',
  'common.delete_confirm': 'هذا الإجراء لا يمكن التراجع عنه. المتابعة؟',
  'dashboard.title': 'لوحة التحكم',
  'dashboard.home': 'الرئيسية',
  'dashboard.subtitle': 'نظرة عامة على نشاطك',
  'dashboard.welcome': 'مرحبًا، {{name}}',
  'dashboard.welcomeSub': 'إليك ملخص ما يحدث في مشاريعك.',
  'dashboard.projects': 'المشاريع',
  'dashboard.analytics': 'التحليلات',
  'dashboard.settings': 'الإعدادات',
  'dashboard.analyticsComingSoon': 'التحليلات ستُتاح قريبًا',
  'dashboard.settingsComingSoon': 'الإعدادات ستُتاح قريبًا',
  'dashboard.loadError': 'تعذّر تحميل بيانات لوحة التحكم.',
  'dashboard.eduflows': 'الدورات التدريبية',
  'dashboard.publishedFlows': 'مسارات منشورة',
  'dashboard.learners': 'المتعلمون',
  'dashboard.newEduFlow': 'دورة تدريبية جديدة',
  'dashboard.newPodcast': 'بودكاست جديد',
  'dashboard.newParcours': 'مسار جديد',
  'dashboard.recentActivity': 'نشاط حديث',
  'dashboard.activityEmpty': 'لا يوجد نشاط حديث على مساراتك أو بودكاستك.',
  'dashboard.kindPodcast': 'بودكاست',
  'dashboard.roleSpecific': 'مساحتك مخصّصة حسب دورك.',
  'pages.analytics.title': 'التحليلات',
  'pages.analytics.description': 'لوحات المعلومات والإحصاءات',
  'pages.analytics.subtitle':
    'صفِّ البيانات، أعد ترتيب المخططات بالسحب والإفلات، وخصّص التخطيط وفق احتياجك.',
  'pages.analytics.filters.period': 'الفترة',
  'pages.analytics.filters.flow': 'الدورة التدريبية',
  'pages.analytics.filters.allFlows': 'كل الدورات',
  'pages.analytics.period.7d': 'آخر 7 أيام',
  'pages.analytics.period.30d': 'آخر 30 يومًا',
  'pages.analytics.period.90d': 'آخر 90 يومًا',
  'pages.analytics.period.365d': 'آخر 12 شهرًا',
  'pages.analytics.addChart': 'إضافة مخطط',
  'pages.analytics.resetLayout': 'إعادة تعيين التخطيط',
  'pages.analytics.dragHint': 'اسحب لإعادة الترتيب',
  'pages.analytics.size.sm': 'S',
  'pages.analytics.size.md': 'M',
  'pages.analytics.size.lg': 'L',
  'pages.analytics.removeChart': 'إزالة هذا المخطط',
  'pages.analytics.kind.completion_line': 'الإكمال عبر الزمن',
  'pages.analytics.kind.learners_bar': 'المتعلمون حسب الوحدة',
  'pages.analytics.kind.status_pie': 'توزيع الحالات',
  'pages.analytics.kind.engagement_area': 'وقت التفاعل',
  'pages.analytics.series.completion': 'معدل الإكمال (%)',
  'pages.analytics.series.learners': 'المتعلمون',
  'pages.analytics.series.hours': 'الساعات',
  'pages.analytics.status.completed': 'مكتمل',
  'pages.analytics.status.in_progress': 'قيد التنفيذ',
  'pages.analytics.status.dropped': 'متروك',
  'pages.analytics.status.not_started': 'لم يبدأ',
  'pages.analytics.loadError': 'تعذّر تحميل بيانات التحليلات.',
  'pages.analytics.retry': 'إعادة المحاولة',
  'pages.analytics.axis.bucket': 'ف. {{n}}',
  'pages.analytics.mock.wd0': 'الإثنين',
  'pages.analytics.mock.wd1': 'الثلاثاء',
  'pages.analytics.mock.wd2': 'الأربعاء',
  'pages.analytics.mock.wd3': 'الخميس',
  'pages.analytics.mock.wd4': 'الجمعة',
  'pages.analytics.mock.wd5': 'السبت',
  'pages.analytics.mock.wd6': 'الأحد',
  'pages.analytics.emptyCharts': 'أضف مخططًا واحدًا على الأقل لعرض البيانات.',
  'pages.analytics.comingSoonDesc':
    'اطّلع على إحصاءات دوراتك، ومعدل الإكمال، وتفاعل المتعلمين، والأداء العام.',
  'common.status.loading': 'جارٍ التحميل…',
  'producerAssignments.intro':
    'يظهر هنا فقط المحتوى الذي عيّنته لك الموارد البشرية صراحةً: بطاقات الكتالوج («قوالب») تُحوَّل إلى مسارات في المصمّم، والبودكاست التي أنت منتجها المكلَّف. إذا كانت القوائم فارغة، فلا توجد لك مهام حاليًا.',
  'producerAssignments.errorForbidden':
    'الوصول مرفوض: دورك لا يتيح استخدام هذه الصفحة. إن كنت مُدرّبًا أو تابعًا للموارد البشرية للمؤسسة، تواصل مع المسؤول.',
  'producerAssignments.errorNoInstitution':
    'حسابك غير مرتبط بمؤسسة في التطبيق (البيانات في القاعدة). على مسؤول ربط حسابك بالمنظمة ثم إعادة تسجيل الدخول.',
  'producerAssignments.errorGeneric': 'تعذّر تحميل مهماتك.',
  'producerAssignments.title': 'مهمات الإنتاج الخاصة بي',
  'producerAssignments.subtitle':
    'دورات يجب إنشاؤها في المصمّم وبودكاست يجب إنتاجها، مُعيّنة من الموارد البشرية.',
  'producerAssignments.createInDesigner': 'إنشاء / فتح دورة',
  'producerAssignments.draft': 'مسوّدة',
  'producerAssignments.enterprise': 'المؤسسة',
  'producerAssignments.enterprisePaths': 'مسارات المؤسسة',
  'producerAssignments.episodes': 'ح.',
  'producerAssignments.formations': 'بطاقات التدريب',
  'producerAssignments.markCompleted': 'تعيين كمكتمل',
  'producerAssignments.markInProgress': 'قيد الإنتاج',
  'producerAssignments.markReady': 'جاهز',
  'producerAssignments.modulesCatalog': '{{count}} وحدة في الكتالوج · حُدّثت {{date}}',
  'producerAssignments.noneEnterprisePaths': 'لا توجد طلبات مسار مؤسسي.',
  'producerAssignments.noneFormations': 'لا توجد بطاقات مُعيَّنة.',
  'producerAssignments.nonePodcasts': 'لا يوجد بودكاست مُعيَّن.',
  'producerAssignments.openInDesigner': 'فتح في المصمّم',
  'producerAssignments.openPodcasts': 'استوديو البودكاست',
  'producerAssignments.planningDeadline': 'آخر أجل {{date}}',
  'producerAssignments.planningFrom': 'بدءًا من {{date}}',
  'producerAssignments.planningRange': '{{start}} ← {{end}}',
  'producerAssignments.podcasts': 'بودكاست للإنتاج',
  'producerAssignments.productionStatus.completed': 'مكتمل',
  'producerAssignments.productionStatus.in_progress': 'قيد التنفيذ',
  'producerAssignments.productionStatus.not_started': 'لم يبدأ',
  'producerAssignments.productionStatus.published': 'منشور',
  'producerAssignments.publishedCatalog': 'منشور في الكتالوج',
  'producerAssignments.rhPlanning': 'تخطيط الموارد البشرية',
  'project.status.published': 'منشور',
  'project.status.archived': 'مؤرشف',
  'project.status.draft': 'مسوّدة',
  'role.teacher': 'مُدرّب',
  'role.institution': 'مؤسسة',
  'role.institution_admin': 'مسؤول المؤسسة',
  'role.admin': 'مسؤول',
  'role.drh': 'مدير الموارد البشرية',
  'role.rh': 'موارد بشرية',
  'role.resp_formation': 'مسؤول التدريب',
  'role.manager': 'مدير',
  'role.collaborator': 'متعاون',
  'role.learner': 'متعلّم',
  'trainerTour.welcome.title': 'مرحبًا في مساحة المُدرّب',
  'trainerTour.welcome.description':
    'تعرّف في لحظات على لوحة التحكم والقائمة. عند زيارة صفحة لأول مرة، يظهر تذكير موجز. يمكنك إغلاق خطوة بالعلامة ✕ ولن تُعاد الزيارة التوجيهية.',
  'trainerTour.dashboard.header.title': 'لوحة تحكمك',
  'trainerTour.dashboard.header.description':
    'نظرة عامة على نشاطك: مؤشرات واختصارات لإنشاء المحتوى بسرعة.',
  'trainerTour.dashboard.actions.title': 'إنشاء محتوى',
  'trainerTour.dashboard.actions.description':
    'اختصارات لدورة EduFlow جديدة أو بودكاست أو مسار. استخدمها لبدء مشروع دون المرور بالقائمة.',
  'trainerTour.dashboard.stats.title': 'المؤشرات',
  'trainerTour.dashboard.stats.description':
    'الدورات والمسارات المنشورة والمتعلمون والبودكاست: راقب حجم كتالوجك بنظرة واحدة.',
  'trainerTour.dashboard.activity.title': 'نشاط حديث',
  'trainerTour.dashboard.activity.description':
    'آخر المحتويات المعدّلة. انقر سطرًا لفتح الدورة أو البودكاست أو المسار.',
  'trainerTour.sidebar.title': 'القائمة الجانبية',
  'trainerTour.sidebar.description':
    'الإدارة (الرئيسية، المتعلمون، التحليلات، المهام)، الإنشاء (التدريب، البودكاست، المسارات، الندوات إن وُفعت)، المكتبة الوسائط ومركز المساعدة.',
  'trainerTour.routes.learners.title': 'المتعلمون',
  'trainerTour.routes.learners.description':
    'قائمة المسجّلين في محتواك، التقدم، التصدير. مركز المتابعة التربوية.',
  'trainerTour.routes.analytics.title': 'التحليلات',
  'trainerTour.routes.analytics.description':
    'جداول ورسوم حول المشاركة والإكمال. خصّص العرض لما يهمّك.',
  'trainerTour.routes.eduflow.title': 'الدورات (EduFlow)',
  'trainerTour.routes.eduflow.description':
    'أنشئ وأدر المسارات التفاعلية، الإصدارات، النشر والمشاركة. قلب التصميم التربوي.',
  'trainerTour.routes.podcasts.title': 'البودكاست',
  'trainerTour.routes.podcasts.description':
    'برامج صوتية، حلقات، الظهور والمشاركة مع مجموعات مؤسستك.',
  'trainerTour.routes.parcours.title': 'المسارات',
  'trainerTour.routes.parcours.description':
    'تسلسل دورات وموارد: هيكِل مسارات طويلة وخصّصها لجمهورك.',
  'trainerTour.routes.videos.title': 'الفيديوهات',
  'trainerTour.routes.videos.description': 'مكتبة فيديو قابلة لإعادة الاستخدام في تدريباتك.',
  'trainerTour.routes.sounds.title': 'الأصوات',
  'trainerTour.routes.sounds.description': 'ملفات صوتية ووسوم لتغذية البودكاست ومقاطع المسارات.',
  'trainerTour.routes.images.title': 'الصور',
  'trainerTour.routes.images.description': 'صور مركزية: استيراد، مجلدات وإعادة استخدام في المحتوى.',
  'trainerTour.routes.documents.title': 'المستندات',
  'trainerTour.routes.documents.description': 'PDF ومرفقات مشتركة مع مشاركة مستهدفة للمتعلّمين.',
  'trainerTour.routes.help.title': 'المساعدة',
  'trainerTour.routes.help.description':
    'مقالات ودروس على LyrraStudio. ارجع إليها عند الحاجة.',
  'trainerTour.routes.producerAssignments.title': 'مهام الإنتاج',
  'trainerTour.routes.producerAssignments.description':
    'عندما يكلّفك الموارد البشرية بإنتاج محتوى (كتالوج المؤسسة)، يظهر هنا مع تقدّم العمل.',
  'trainerTour.routes.webinars.title': 'الندوات عبر الإنترنت',
  'trainerTour.routes.webinars.description':
    'خطّط جلسات مباشرة، دعوات وروابط البث لمجموعاتك.',
  'pages.learners.title': 'المتعلمون',
  'pages.learners.description': 'تتبّع تقدم متعلميك',
  'pages.learners.enrolledFormations': 'الدورات المسجّل فيها',
  'pages.learners.notStarted': 'لم يبدأ',
  'pages.learners.startedOn': 'بدء {{date}}',
  'pages.learners.detailedTraces': 'سجل النشاط التفصيلي · {{flowTitle}}',
  'pages.learners.statsEvents': 'الأحداث: {{count}}',
  'pages.learners.statsResponses': 'الإجابات: {{count}}',
  'pages.learners.statsBlockSessions': 'جلسات الأقسام: {{count}}',
  'pages.learners.timePerBlock': 'الوقت لكل قسم',
  'pages.learners.lastEvents': 'آخر الأحداث',
  'pages.learners.blockSessionInProgress': '(قيد التنفيذ)',
  'pages.learners.blockTimeOnBlock': '({{duration}} في هذا القسم)',
  'pages.learners.trackingEvent.unknown': 'حدث',
  'pages.learners.trackingEvent.training_enter': 'فتح الدورة',
  'pages.learners.trackingEvent.training_exit': 'مغادرة أو إغلاق الدورة',
  'pages.learners.trackingEvent.training_completed': 'اكتملت الدورة',
  'pages.learners.trackingEvent.block_enter': 'دخول قسم',
  'pages.learners.trackingEvent.block_exit': 'مغادرة قسم',
  'pages.learners.trackingEvent.response_submitted': 'إرسال إجابة',
  'pages.learners.trackingEvent.progress_sync': 'مزامنة التقدم',
  'pages.learners.refresh': 'تحديث',
  'pages.learners.exportCsv': 'تصدير CSV',
  'pages.learners.statTotal': 'إجمالي المتعلمين',
  'pages.learners.statInProgress': 'قيد التنفيذ',
  'pages.learners.statCompleted': 'مكتمل',
  'pages.learners.statAvgProgress': 'متوسط التقدم',
  'pages.learners.searchPlaceholder': 'بحث بالاسم أو البريد…',
  'pages.learners.filterAllFlows': 'كل الدورات',
  'pages.learners.sortRecent': 'الأحدث',
  'pages.learners.sortName': 'الاسم أ-ي',
  'pages.learners.sortProgress': 'التقدم',
  'pages.learners.colLearner': 'متعلم',
  'pages.learners.colFormations': 'الدورات',
  'pages.learners.colProgress': 'التقدم',
  'pages.learners.colCompleted': 'مكتمل',
  'pages.learners.colTime': 'الوقت',
  'pages.learners.colLastAccess': 'آخر وصول',
  'pages.learners.colActions': 'إجراءات',
  'pages.learners.openProgressDashboard': 'لوحة تقدُّم التعلّم',
  'pages.learners.dashboardTitle': 'تقدُّم المتعلّم',
  'pages.learners.dashboardBack': 'العودة إلى القائمة',
  'pages.learners.dashboardInvalidId': 'معرّف المتعلّم غير صالح',
  'pages.learners.dashboardNotFound': 'المتعلّم غير موجود أو الوصول مرفوض',
  'pages.learners.dashboardOverviewHint':
    'عرض موحّد: دورات EduFlow للمشارك، والمسارات والبودكاست المخصّصة لحساب Lyrra بنفس البريد.',
  'pages.learners.tabOverview': 'نظرة عامة',
  'pages.learners.tabFormations': 'الدورات',
  'pages.learners.tabParcours': 'المسارات',
  'pages.learners.tabPodcasts': 'البودكاست',
  'pages.learners.sectionFormations': 'الدورات',
  'pages.learners.sectionParcours': 'المسارات',
  'pages.learners.sectionPodcasts': 'البودكاست',
  'pages.learners.emptyParcours': 'لا مسار مخصّص لحساب Lyrra بهذا البريد.',
  'pages.learners.emptyPodcasts': 'لا بودكاست مخصّص لحساب Lyrra بهذا البريد.',
  'pages.learners.linkedAccountHint':
    'تظهر المسارات والبودكاست عند وجود مستخدم Lyrra يطابق بريد المشارك.',
  'pages.learners.kpiEduflows': 'الدورات',
  'pages.learners.kpiAvgProgress': 'متوسط التقدّم',
  'pages.learners.kpiPaths': 'المسارات',
  'pages.learners.kpiPodcasts': 'البودكاست',
  'pages.learners.kpiCompletedFormations': '{{count}} مكتملة',
  'pages.learners.pathProgressLabel': '{{done}} / {{total}} أنشطة',
  'pages.learners.pathAssignedOn': 'أُضيف في {{date}}',
  'pages.learners.podcastCompleted': 'مكتمل',
  'pages.learners.podcastInProgress': 'قيد التنفيذ',
  'pages.learners.pathStatusPublished': 'منشور',
  'pages.learners.pathStatusDraft': 'مسودّة',
  'pages.learners.openInDesigner': 'فتح في المصمّم',
  'pages.learners.openParcoursEditor': 'فتح المسار',
  'pages.learners.viewPodcasts': 'عرض البودكاست',
  'a11y.skipToContent': 'تخطٍ إلى المحتوى الرئيسي',
  'a11y.skipToNav': 'تخطٍ إلى التنقل',
  'a11y.skipLinksLandmark': 'روابط الوصول السريع',
  'player.lightMode': 'الوضع الفاتح',
  'player.darkMode': 'الوضع الداكن',
  'player.next': 'التالي',
  'player.previous': 'السابق',
  'player.exit': 'خروج',
  'player.fullscreen': 'ملء الشاشة',
  'player.exitFullscreen': 'إنهاء ملء الشاشة',
  'player.previewBanner': 'وضع المعاينة — تعرض هذه الشاشة البيانات الحقيقية لتدريبك',
  'player.flowPreviewMap': 'مخطط المسار',
  'player.flowPreviewTitle': 'معاينة المسار',
  'player.flowPreviewHint': 'نظرة عامة على البنى والروابط بين الأقسام.',
  'player.flowPreviewLegendCurrent': 'القسم المعروض',
  'player.flowPreviewClose': 'إغلاق',
  'player.closePreview': 'إغلاق المعاينة',
  'player.sidebarExpand': 'توسيع اللوحة',
  'player.sidebarCollapse': 'طي اللوحة',
  'header.userAvatar': 'صورة المستخدم',
  'header.userMenu': 'قائمة المستخدم',
  'nav.sidebarNavigation': 'التنقل الرئيسي',
  'player.toggleSidebarShow': 'إظهار اللوحة',
  'player.toggleSidebarHide': 'إخفاء اللوحة',
  'player.institutionLogo': 'شعار المؤسسة',
  'player.a11yCenter': 'مركز إمكانية الوصول',
  'a11y.skipToPlayerMain': 'تخطٍ إلى محتوى التدريب',
  'a11y.playerMainLandmark': 'محتوى التدريب',
  'form.language': 'اللغة',
  'breadcrumb.label': 'مسار التنقل',
  'breadcrumb.home': 'الرئيسية',
  'breadcrumb.dashboard': 'لوحة التحكم',
  'breadcrumb.projects': 'المشاريع',
  'breadcrumb.eduflow': 'الدورات',
  'breadcrumb.learners': 'المتعلمون',
  'breadcrumb.analytics': 'التحليلات',
  'breadcrumb.videos': 'الفيديوهات',
  'breadcrumb.sounds': 'الأصوات',
  'breadcrumb.images': 'الصور',
  'breadcrumb.documents': 'المستندات',
  'breadcrumb.store': 'المتجر',
  'breadcrumb.help': 'المساعدة',
  'breadcrumb.admin': 'الإدارة',
  'breadcrumb.settings': 'الإعدادات',
  'breadcrumb.profile': 'الملف الشخصي',
  'breadcrumb.groups': 'المجموعات',
  'breadcrumb.branding': 'الهوية البصرية',
  'breadcrumb.landingPage': 'الصفحة الرئيسية',
  'breadcrumb.webhooks': 'Webhooks',
  'breadcrumb.campaigns': 'الحملات',
  'breadcrumb.competencies': 'الكفاءات',
  'breadcrumb.compliance': 'الامتثال',
  'breadcrumb.reports': 'التقارير',
  'breadcrumb.budget': 'الميزانية',
  'breadcrumb.catalog': 'الكتالوج',
  'breadcrumb.integrations': 'التكاملات',
  'breadcrumb.requests': 'الطلبات',
  'breadcrumb.team': 'الفريق',
  'breadcrumb.reviews': 'التقييمات',
  'breadcrumb.training': 'التدريب',
  'breadcrumb.skills': 'المهارات',
  'breadcrumb.certificates': 'الشهادات',
  'breadcrumb.new': 'جديد',
  'breadcrumb.edit': 'تعديل',
  'breadcrumb.podcasts': 'البودكاست',
  'breadcrumb.episodes': 'الحلقات',
  'breadcrumb.parcours': 'المسارات',
  'breadcrumb.producerAssignments': 'مهام الإنتاج',
  'footer.madeWith': 'صُنع بـ',
  'footer.forEducation': 'من أجل التعليم',
  'footer.terms': 'الشروط',
  'footer.privacy': 'الخصوصية',
  'footer.accessibility': 'إمكانية الوصول',
  'footer.legal': 'روابط قانونية',
  'search.title': 'بحث',
  'search.placeholder': 'ابحث عن الدورات، البودكاست، المسارات…',
  'search.input': 'حقل البحث',
  'search.pages': 'صفحات',
  'search.formations': 'دورات تدريبية',
  'search.podcasts': 'بودكاست',
  'search.parcours': 'مسارات',
  'search.recent': 'حديث',
  'search.noResults': 'لا نتائج لـ «{{query}}»',
  'search.select': 'للاختيار',
  'search.navigate': 'للتنقل',
  'search.close': 'للإغلاق',

  'eduflowList.status.draft': 'مسودة',
  'eduflowList.status.published': 'منشور',
  'eduflowList.status.archived': 'مؤرشف',
  'eduflowList.badge.enterpriseShell': 'طلب مؤسسة',
  'eduflowList.badge.enterpriseLinked': 'مؤسسة',
  'eduflowList.badge.toProduce': 'للإنتاج',

  'eduflow.list.blocksCount': '{{count}} كتلة',
  'eduflow.list.noContent': 'لا محتوى',
  'eduflow.list.minutesShort': '{{count}} د',
  'eduflow.list.tooltip.openMissions': 'فتح مهام الإنتاج',
  'eduflow.list.tooltip.edit': 'تعديل',
  'eduflow.list.shellHint':
    'بطاقة محددة من مؤسستكم — أنشئوا EduFlow من «مهام الإنتاج».',
  'eduflow.list.title': 'الدورات',
  'eduflow.list.subtitle': 'صمّموا تجارب تعلّم تفاعليّة',
  'eduflow.list.searchPlaceholder': 'ابحث عن دورة…',
  'eduflow.list.import': 'استيراد',
  'eduflow.list.importHint': 'حزمة .lyrra (وسائط مضمنة) أو تصدير JSON القديم Lyrra V1.',
  'eduflow.list.importSuccess': 'تم استيراد الدورة. جاري فتح المُصمّم.',
  'eduflow.list.importError':
    'تعذّر الاستيراد — تحقّقوا من الملف (.lyrra أو تصدير JSON صالح، كتلة واحدة على الأقل).',
  'eduflow.list.filterAll': 'الكل',
  'eduflow.list.filterDraft': 'مسودات',
  'eduflow.list.filterPublished': 'منشورة',
  'eduflow.list.filterArchived': 'مؤرشفة',
  'eduflow.list.archiveFormation': 'أرشفة الدورة',
  'eduflow.list.restoreFromArchive': 'استعادة من الأرشيف (مسودة)',
  'eduflow.list.archiveSuccess': 'تم أرشفة الدورة',
  'eduflow.list.archiveError': 'تعذّر أرشفة الدورة.',
  'eduflow.list.restoreSuccess': 'تمت استعادة الدورة كمسودة',
  'eduflow.list.restoreError': 'تعذّر استعادة الدورة.',
  'eduflow.list.viewModeGrid': 'عرض شبكي',
  'eduflow.list.viewModeList': 'عرض قائمة',
  'eduflow.list.viewByCategory': 'عرض حسب الفئة',
  'eduflow.list.categoryBack': 'كل الفئات',
  'eduflow.list.categoryBrowseHint': 'اختروا فئة لعرض دوراتها.',
  'eduflow.list.categoryFormationCount': '{{count}} دورة',
  'eduflow.list.categoryEmptyFiltered': 'لا دورات في هذا العرض (فلتر أو بحث نشط).',
  'eduflow.list.uncategorizedCardHint': 'دورات بلا تصنيف.',
  'eduflow.list.uncategorized': 'بلا فئة',
  'eduflow.list.manageCategories': 'إدارة الفئات',
  'eduflow.list.categoriesPanelTitle': 'فئات الدورة',
  'eduflow.list.noCategoryAvailable': 'لا فئات متاحة.',
  'eduflow.list.categoriesSaveError': 'تعذّر حفظ الفئات.',
  'eduflow.list.emptyFilteredTitle': 'لا نتائج',
  'eduflow.list.emptyFilteredHint': 'جرّبوا تغيير البحث أو عوامل التصفية.',
  'eduflow.list.emptyFirstTitle': 'أنشئوا دورتكم الأولى',
  'eduflow.list.emptyFirstHint': 'ابنوا تعلّمًا تفاعليًا باستخدام المُصمّم البصري.',
  'eduflow.list.emptyCreateCta': 'إنشاء دورتي الأولى',
  'eduflow.list.deleteToTrashTitle': 'نقل الدورة إلى سلة المهملات؟',
  'eduflow.list.deleteToTrashBody':
    'ستُزال «{{title}}» من قائمتكم (حذف منطقي). يمكن لمؤسستكم استعادتها من سلة مهلكات المؤسسة.',
  'eduflow.list.deleteToTrashConfirm': 'نقل إلى سلة المهملات',
  'eduflow.list.coverLabel': 'صورة الغلاف',
  'eduflow.list.coverRemove': 'إزالة الغلاف',
  'eduflow.list.coverUpload': 'اختيار صورة',
  'eduflow.list.flowProperties': 'العنوان والوصف والغلاف',
  'eduflow.list.propertiesPanelTitle': 'خصائص الدورة',
  'eduflow.list.duplicatePanelTitle': 'نسخ الدورة',
  'eduflow.list.duplicatePanelSubtitle': 'الدورة الأصلية: {{name}}',
  'eduflow.list.duplicateTitleSuffix': 'نسخة',
  'eduflow.list.duplicateSuccess': 'تم نسخ الدورة.',
  'eduflow.list.duplicateCoverHint': 'سيُستخدم غلاف الدورة الأصلية ومحتواها التعليمي.',
  'eduflow.list.propertiesSaveError': 'تعذّر حفظ الخصائص.',
  'eduflow.list.propertiesSaved': 'تم حفظ الخصائص.',
  'eduflow.list.propertiesUploadError': 'فشل رفع الصورة.',

  'eduflow.createFormation.panelTitle': 'دورة جديدة',
  'eduflow.createFormation.panelSubtitle':
    'أدخلوا العنوان والوصف. بعد التأكيد تُنشأ الدورة ويُفتح المُصمّم لبناء المسار.',
  'eduflow.createFormation.titleLabel': 'العنوان',
  'eduflow.createFormation.descriptionLabel': 'الوصف',
  'eduflow.createFormation.titlePlaceholder': 'مثال: مقدّمة وحدة السلامة',
  'eduflow.createFormation.descriptionPlaceholder': 'الأهداف، الجمهور، إلخ. (اختياري)',
  'eduflow.createFormation.validate': 'إنشاء وفتح المُصمّم',
  'eduflow.createFormation.titleRequired': 'العنوان إلزامي.',
  'eduflow.createFormation.error': 'تعذّر إنشاء الدورة.',

  'eduflow.shareFormation.title': 'مشاركة الدورة',
  'eduflow.shareFormation.publicLinkTitle': 'رابط عام (دون تسجيل دخول)',
  'eduflow.shareFormation.publicLinkCopy': 'نسخ الرابط',
  'eduflow.shareFormation.publicLinkCopied': 'تم النسخ',
  'eduflow.shareFormation.publishRequired': 'انشروا الدورة للحصول على رابط يعمل دون تسجيل دخول.',
  'eduflow.shareFormation.embedTitle': 'زر تضمين ومشغّل في نافذة',
  'eduflow.shareFormation.embedHint':
    'الصقوا هذا المقطع في موقعكم. ضمّنوا السكربت مرة واحدة في الصفحة؛ لدورات إضافية أضيفوا أزرارًا بنسخ سطر الزر وتغيير الرابط في data-lyrra-eduflow-url. يتضمن رابط المشغّل sidebar=0 لإخفاء جدول المحتويات مبدئيًا في التضمين.',
  'eduflow.shareFormation.embedCopy': 'نسخ HTML',
  'eduflow.shareFormation.embedCopied': 'تم النسخ',
  'eduflow.shareFormation.embedCloseAria': 'إغلاق',
  'eduflow.shareFormation.embedButtonLabel': 'فتح: {{title}}',
  'eduflow.shareFormation.embedToggle': 'تضمين في الموقع',
  'eduflow.shareFormation.removeAccessSuccess': 'تم سحب الوصول للمتعلّم.',
  'eduflow.shareFormation.removeAccessError': 'تعذّر سحب وصول المتعلّم.',
  'eduflow.shareFormation.assignSuccess': 'تمت مشاركة الدورة وإرسال بريد الدعوة.',
  'eduflow.shareFormation.assignError': 'تعذّر تعيين هذا المتعلّم.',
  'eduflow.shareFormation.createAssignSuccess': 'تم إنشاء/ربط الحساب وتعيين الدورة وإرسال بريد الدعوة.',
  'eduflow.shareFormation.createLearnerError': 'تعذّر إنشاء المتعلّم.',
  'eduflow.shareFormation.selectExistingLearner': 'اختيار متعلّم قائم',
  'eduflow.shareFormation.searchLearnerPlaceholder': 'بحث متعلّم (اسم، كنية، بريد)',
  'eduflow.shareFormation.loadingLearners': 'جاري تحميل المتعلّمين…',
  'eduflow.shareFormation.noLearnerAvailable': 'لا متعلّمين متاحين.',
  'eduflow.shareFormation.hideQuickCreate': 'إخفاء الإنشاء السريع',
  'eduflow.shareFormation.createNewLearner': 'إنشاء متعلّم جديد',
  'eduflow.shareFormation.firstNameRequired': 'الاسم الأول *',
  'eduflow.shareFormation.lastNameRequired': 'اسم العائلة *',
  'eduflow.shareFormation.emailRequired': 'البريد *',
  'eduflow.shareFormation.createShareInvite': 'إنشاء ومشاركة وإرسال الدعوة',
  'eduflow.shareFormation.assignedLearnersCount_zero': 'لا متعلّمين مُعيَّنين',
  'eduflow.shareFormation.assignedLearnersCount_one': 'متعلّم واحد مُعيَّن',
  'eduflow.shareFormation.assignedLearnersCount_other': '{{count}} متعلّم مُعيَّن',
  'eduflow.shareFormation.noAssignedLearner': 'لا متعلّمين مُعيَّنين لهذه الدورة.',
  'eduflow.shareFormation.removeAccessTitle': 'سحب الوصول',
  'eduflow.shareFormation.inviteEmailsTitle': 'دعوة بالبريد (حساب قائم)',
  'eduflow.shareFormation.inviteEmailsHint':
    'عنوان واحد أو أكثر: حسابات LyrraStudio فقط (بما فيها مؤسسة أخرى). من بلا حساب يُتخطّاهم — استخدموا «إنشاء متعلّم جديد» لدعوتهم.',
  'eduflow.shareFormation.inviteEmailsPlaceholder':
    'عنوان في كل سطر أو مفصول بفواصل\nexample@company.com، other@org.fr',
  'eduflow.shareFormation.inviteEmailsSubmit': 'إضافة هذه الحسابات إلى الدورة',
  'eduflow.shareFormation.inviteEmailsInvalid': 'أدخلوا عنوان بريد صالحًا واحدًا على الأقل.',
  'eduflow.shareFormation.inviteEmailsError': 'تعذّر إضافة العناوين.',
  'eduflow.shareFormation.inviteEmailsSummaryOk': 'تمت إضافة {{count}} حساب(ات).',
  'eduflow.shareFormation.inviteEmailsSummaryNoAccount': '{{count}} بلا حساب LyrraStudio.',
  'eduflow.shareFormation.inviteEmailsSummaryAlready': '{{count}} مُعيَّنون مسبقًا.',

  'eduflow.duplicateFlowError': 'تعذّر تكرار الدورة.',
  'eduflow.collaborativeBadge': 'تعاوني',
  ...arEduflowDesignerExtras,

  'podcasts.title': 'البودكاست',
  'podcasts.actions.cancel': 'إلغاء',
  'podcasts.actions.close': 'إغلاق',
  'podcasts.actions.create': 'إنشاء',
  'podcasts.actions.edit': 'تعديل',
  'podcasts.actions.retry': 'إعادة المحاولة',
  'podcasts.actions.save': 'حفظ',
  'podcasts.actions.saving': 'جاري الحفظ…',
  'podcasts.actions.share': 'مشاركة',
  'podcasts.category.ariaGroup': 'فئة البودكاست',
  'podcasts.category.emptyBanner':
    'أضيفوا فئات في مساحة المؤسسة لتنظيم البودكاست بشكل أفضل.',
  'podcasts.category.emptyInstitutionHint': 'لا فئات مؤسسيّة بعد — يمكنكم النشر بدونها.',
  'podcasts.category.noneChip': 'بلا فئة',
  'podcasts.category.sectionTitle': 'الفئة',
  'podcasts.category.withCategoriesHint': 'التصنيف في الكتالوج والتصفية لدى المؤسسة.',
  'podcasts.cover.ariaDropzone': 'اختيار أو إفلات صورة الغلاف',
  'podcasts.cover.browseFiles': 'تصفح الملفات',
  'podcasts.cover.cancelNewFile': 'إلغاء الملف الجديد',
  'podcasts.cover.dragDrop': 'اسحبوا وأفلتوا صورة',
  'podcasts.cover.dropHere': 'أفلتوا الصورة هنا',
  'podcasts.cover.errorMaxSize': 'يجب ألا يتجاوز حجم الصورة ٥ ميغابايت.',
  'podcasts.cover.errorUnsupportedFormat': 'صيغة الصورة غير مدعومة.',
  'podcasts.cover.formatsHint': 'PNG، JPG، WebP، GIF — 5 ميغابايت كحد أقصى',
  'podcasts.cover.help':
    'يُفضّل مربّع الشكل. اسحبوا وأفلتوا ملفًا أو انقروا للتصفح.',
  'podcasts.cover.or': 'أو',
  'podcasts.cover.replaceHint': 'استبدال الصورة',
  'podcasts.cover.sectionTitle': 'صورة الغلاف',
  'podcasts.deleteDialog.body':
    'ستُزال «{{title}}» من القائمة (حذف منطقي). الحلقات لا تُمحى. إذا كان حسابكم مرتبطًا بمؤسسة، يمكن للمسؤول استعادة البودكاست من سلة مهلكات مساحة المؤسسة.',
  'podcasts.deleteDialog.confirm': 'نقل إلى سلة المهملات',
  'podcasts.deleteDialog.title': 'نقل البودكاست إلى سلة المهملات؟',
  'podcasts.editPanel.createdOn': 'أُنشئ في ',
  'podcasts.editPanel.headerTitle': 'تعديل البودكاست',
  'podcasts.editPanel.saving': 'جاري الحفظ…',
  'podcasts.editPanel.statsEpisodes': 'الحلقات: ',
  'podcasts.editPanel.statsSubscribers': 'المشتركون: ',
  'podcasts.editPanel.successSaved': 'تم حفظ التعديلات',
  'podcasts.episodeStatus.draft': 'مسودة',
  'podcasts.episodeStatus.published': 'منشور',
  'podcasts.episodesPanel.addEpisode': 'إضافة حلقة',
  'podcasts.episodesPanel.emptySubtitle': 'أضيفوا حلقات إلى هذا البودكاست',
  'podcasts.episodesPanel.emptyTitle': 'لا حلقات',
  'podcasts.episodesPanel.episodeCount': '{{count}} حلقة',
  'podcasts.episodesPanel.noEpisodeAvailable': 'لا حلقات متاحة',
  'podcasts.episodesPanel.remove': 'إزالة',
  'podcasts.episodesPanel.searchPlaceholder': 'بحث عن حلقة…',
  'podcasts.episodesPanel.title': 'حلقات البودكاست',
  'podcasts.error.retry': 'إعادة المحاولة',
  'podcasts.filters.allCategories': 'كل الفئات',
  'podcasts.filters.categoryLabel': 'الفئة',
  'podcasts.filters.searchLabel': 'بحث نصّي',
  'podcasts.filters.searchPlaceholder': 'عنوان، وصف…',
  'podcasts.filters.viewCategories': 'عرض الفئات',
  'podcasts.filters.viewList': 'عرض القائمة',
  'podcasts.filters.viewGrid': 'شبكة',
  'podcasts.form.descriptionLabel': 'الوصف',
  'podcasts.form.descriptionPlaceholder': 'صفوا بودكاستكم…',
  'podcasts.form.namePlaceholder': 'اسم البودكاست',
  'podcasts.form.titleLabel': 'العنوان',
  'podcasts.language.ariaGroup': 'لغة البودكاست',
  'podcasts.language.help':
    'من بين لغات المنصّة العشر — لمواءمة البودكاست مع لغة مشغّل المتعلّم وواجهته.',
  'podcasts.language.label': 'اللغة',
  'podcasts.lightbox.ariaClose': 'إغلاق',
  'podcasts.lightbox.ariaDialog': 'معاينة غلاف البودكاست',
  'podcasts.list.actionActivate': 'تفعيل',
  'podcasts.list.actionDeactivate': 'إلغاء التفعيل',
  'podcasts.list.actionDelete': 'حذف',
  'podcasts.list.filterAll': 'الكل',
  'podcasts.list.filterArchived': 'مؤرشف',
  'podcasts.list.archivePodcast': 'أرشفة البودكاست',
  'podcasts.list.restoreFromArchive': 'استعادة من الأرشيف',
  'podcasts.list.archiveSuccess': 'تم أرشفة البودكاست',
  'podcasts.list.archiveError': 'تعذّر أرشفة البودكاست.',
  'podcasts.list.restoreSuccess': 'تمت استعادة البودكاست',
  'podcasts.list.restoreError': 'تعذّر استعادة البودكاست.',
  'podcasts.list.badgeArchived': 'مؤرشف',
  'podcasts.list.emptyArchivedNone': 'لا بودكاست مؤرشفة.',
  'podcasts.list.emptyAllArchived':
    'كل البودكاست مؤرشفة. افتحوا تبويب «مؤرشف» لعرضها.',
  'podcasts.list.actionManageEpisodes': 'إدارة الحلقات',
  'podcasts.list.actionPreview': 'معاينة واستماع',
  'podcasts.list.coverPreviewAria': 'معاينة غلاف البودكاست {{title}}',
  'podcasts.list.createFirst': 'إنشاء بودكاست',
  'podcasts.list.emptySubtitle': 'أنشئوا أول بودكاست لكم للبدء',
  'podcasts.list.emptyTitle': 'لا بودكاست',
  'podcasts.list.loadError': 'تعذّر تحميل البودكاست.',
  'podcasts.list.enterpriseBadge': 'مؤسسة',
  'podcasts.list.enterpriseNeedTitle': 'طلب محدّد من شركتكم',
  'podcasts.list.episodesShort': '{{count}} حلقة',
  'podcasts.list.groupPodcastCount': '{{count}} بودكاست',
  'podcasts.list.subscribersShort': '{{count}} مشترك',
  'podcasts.list.uncategorized': 'بلا فئة',
  'podcasts.list.categoryBack': 'كل الفئات',
  'podcasts.list.categoryBrowseHint': 'اختروا فئة لعرض بودكاستها.',
  'podcasts.list.categoryEmptyFiltered': 'لا بودكاست في هذا العرض (بحث نشط).',
  'podcasts.list.uncategorizedCardHint': 'بودكاست بلا فئة مُعيَّنة.',
  'podcasts.modal.errorRequiredFields': 'العنوان والوصف إلزاميان.',
  'podcasts.modal.errorSaveFailed': 'خطأ أثناء الحفظ.',
  'podcasts.modal.subtitleNew':
    'أدخلوا العنوان والوصف والخيارات. يمكنكم إضافة الحلقات لاحقًا.',
  'podcasts.modal.titleEdit': 'تعديل البودكاست',
  'podcasts.modal.titleNew': 'بودكاست جديد',
  'podcasts.page.episodesLink': 'الحلقات',
  'podcasts.page.newButton': 'جديد',
  'podcasts.page.title': 'البودكاست',
  'podcasts.page.totalCount': '{{count}} بودكاست',
  'podcasts.pagination.pageOf': 'صفحة {{page}} / {{total}}',
  'podcasts.pagination.totalSummary': 'إجمالي {{count}} بودكاست',
  'podcasts.player.listen': 'استماع',
  'podcasts.player.noAudio': 'لا صوت',
  'podcasts.player.pause': 'إيقاف مؤقت',
  'podcasts.preview.emptySubtitle': 'لا حلقات لهذا البودكاست بعد',
  'podcasts.preview.emptyTitle': 'لا حلقات',
  'podcasts.preview.episodeCount': '{{count}} حلقة',
  'podcasts.preview.fallbackDescription': 'استمعوا إلى الحلقات الصوتيّة المتاحة.',
  'podcasts.preview.playAll': 'تشغيل الكل',
  'podcasts.preview.title': 'معاينة البودكاست',
  'podcasts.share.assignedLearnersHeading': '{{count}} متعلّم مُعيَّن',
  'podcasts.share.copied': 'تم النسخ',
  'podcasts.share.copyLink': 'نسخ الرابط',
  'podcasts.share.emailPlaceholder': 'البريد *',
  'podcasts.share.errorCreateLearner': 'تعذّر إنشاء المتعلّم.',
  'podcasts.share.errorPublicLink': 'تعذّر إنشاء الرابط العام.',
  'podcasts.share.errorRemoveLearner': 'تعذّر سحب المتعلّم.',
  'podcasts.share.errorShare': 'تعذّر مشاركة هذا البودكاست.',
  'podcasts.share.firstNamePlaceholder': 'الاسم الأول *',
  'podcasts.share.generatingLink': 'جاري إنشاء الرابط…',
  'podcasts.share.hideQuickCreate': 'إخفاء الإنشاء السريع',
  'podcasts.share.lastNamePlaceholder': 'اسم العائلة *',
  'podcasts.share.loadingAssigned': 'جاري التحميل…',
  'podcasts.share.loadingLearners': 'جاري تحميل المتعلّمين…',
  'podcasts.share.messageAccessRemoved': 'تم سحب وصول المتعلّم.',
  'podcasts.share.messageCreatedAndShared':
    'تم إنشاء/ربط الحساب ومشاركة البودكاست وإرسال بريد الدعوة.',
  'podcasts.share.messageShared': 'تمت مشاركة البودكاست وإرسال الدعوة للمتعلّم.',
  'podcasts.share.noAssignedLearners': 'لا متعلّمين مُعيَّنين لهذا البودكاست.',
  'podcasts.share.noLearnerAvailable': 'لا متعلّمين متاحين.',
  'podcasts.share.panelTitle': 'مشاركة البودكاست',
  'podcasts.share.publicLinkSection': 'رابط عام (دون تسجيل دخول)',
  'podcasts.share.removeAccessTitle': 'سحب الوصول',
  'podcasts.share.searchLearnerPlaceholder': 'بحث متعلّم (اسم، كنية، بريد)',
  'podcasts.share.selectExistingLearnerLabel': 'اختيار متعلّم قائم',
  'podcasts.share.showQuickCreate': 'إنشاء متعلّم جديد',
  'podcasts.share.submitCreateAndInvite': 'إنشاء ومشاركة وإرسال الدعوة',
  'podcasts.status.active': 'نشط',
  'podcasts.status.inactive': 'غير نشط',

  'podcast.episodes.pageTitle': 'الحلقات',
  'podcast.episodes.count': '{{count}} حلقة',
  'podcast.episodes.newEpisode': 'حلقة جديدة',
  'podcast.episodes.searchPlaceholder': 'بحث حسب العنوان…',
  'podcast.episodes.filterAllStatuses': 'كل الحالات',
  'podcast.episodes.filterDraft': 'مسودة',
  'podcast.episodes.filterPublished': 'منشور',
  'podcast.episodes.emptyTitle': 'لا توجد حلقات',
  'podcast.episodes.emptyHint': 'أنشئوا أول حلقة للبدء',
  'podcast.episodes.emptyCreateCta': 'إنشاء حلقة',
  'podcast.episodes.backPodcasts': 'البودكاست',
  'podcast.episodes.paginationTotal': 'إجمالي {{total}} حلقة',
  'podcast.episodes.pageOf': 'صفحة {{page}} / {{totalPages}}',
  'podcast.episodes.deleteTitle': 'حذف الحلقة؟',
  'podcast.episodes.deleteHint': 'سيتم حذف «{{title}}» نهائيًا.',
  'podcast.episodes.deleteCancel': 'إلغاء',
  'podcast.episodes.deleteConfirm': 'حذف',
  'podcast.episodes.statusPublished': 'منشور',
  'podcast.episodes.statusDraft': 'مسودة',
  'podcast.episodes.noDescription': 'بلا وصف',
  'podcast.episodes.noAudio': 'لا صوت',
  'podcast.episodes.retry': 'إعادة المحاولة',
  'podcast.episodes.chapters': 'الفصول',
  'podcast.episodes.hideText': 'إخفاء النص',
  'podcast.episodes.noChapters': 'لا فصول متاحة.',
  'podcast.episodes.previewEpisodeTitle': 'حلقة',
  'podcast.episodes.showText': 'إظهار النص',
  'podcast.episodes.listen': 'استماع',
  'podcast.episodes.noAudioShort': 'لا يتوفر صوت',
  'podcast.episodes.edit': 'تعديل',
  'podcast.episodes.delete': 'حذف',
  'podcast.episodes.unmute': 'تشغيل الصوت',
  'podcast.episodes.mute': 'كتم الصوت',
  'podcast.episodes.totalEpisodes': '{{count}} حلقة إجمالًا',
  'podcast.createEpisode.panelTitle': 'حلقة جديدة',
  'podcast.createEpisode.panelSubtitle':
    'أدخلوا العنوان واختياريًا الوصف والصورة. بعد التأكيد تُنشأ الحلقة ويُفتح المحرّر لإعداد المحتوى.',
  'podcast.createEpisode.titleLabel': 'العنوان',
  'podcast.createEpisode.descriptionLabel': 'الوصف',
  'podcast.createEpisode.coverLabel': 'صورة الغلاف (اختياري)',
  'podcast.createEpisode.coverHint': 'JPEG أو PNG أو WebP أو GIF — ٥ ميغابايت كحد أقصى.',
  'podcast.createEpisode.coverChoose': 'اختيار صورة',
  'podcast.createEpisode.coverRemove': 'إزالة الصورة',
  'podcast.createEpisode.titlePlaceholder': 'مثال: مقدمة وحدة السلامة',
  'podcast.createEpisode.descriptionPlaceholder': 'ملخص، أهداف… (اختياري)',
  'podcast.createEpisode.validate': 'إنشاء وفتح المحرّر',
  'podcast.createEpisode.titleRequired': 'العنوان إلزامي.',
  'podcast.createEpisode.error': 'تعذّر إنشاء الحلقة.',
  'podcast.createEpisode.uploadCoverError': 'تم إنشاء الحلقة لكن فشل رفع الصورة.',
  'podcast.createEpisode.coverTooLarge': 'يجب ألا يتجاوز حجم الصورة ٥ ميغابايت.',

  'podcasts.episodeEditor': 'محرّر الحلقة',
  'podcast.editor.defaultNewTitle': 'حلقة جديدة',

  'episodeEditor.voicePicker.blockVoice': 'صوت هذا القطعة',
  'episodeEditor.voicePicker.defaultVoice': 'الصوت الافتراضي',
  'episodeEditor.voicePicker.voice': 'صوت',
  'episodeEditor.voicePicker.voices': 'أصوات',
  'episodeEditor.voicePicker.searchPlaceholder': 'ابحث عن صوت…',
  'episodeEditor.voicePicker.noVoiceFound': 'لا يوجد صوت مطابق',
  'episodeEditor.voicePicker.female': 'أنثى',
  'episodeEditor.voicePicker.male': 'ذكر',
  'episodeEditor.voicePicker.stop': 'إيقاف',
  'episodeEditor.voicePicker.preview': 'معاينة الصوت',
  'episodeEditor.voicePicker.stopPlayback': 'إيقاف التشغيل',
  'episodeEditor.errors.notFound': 'الحلقة غير موجودة',
  'episodeEditor.errors.titleRequired': 'العنوان مطلوب.',
  'episodeEditor.errors.saveFailed': 'خطأ أثناء الحفظ.',
  'episodeEditor.errors.noVoicesAvailable':
    'لا أصوات Mistral متاحة. أدخلوا مفتاح واجهة البرمجة في الإدارة ← تكاملات المنصة ← Mistral AI، ثم أعيدوا تحميل الصفحة.',
  'episodeEditor.errors.selectVoiceFirst':
    'اختر صوتًا من تبويب «الصوت» قبل توليد التعليق الصوتي.',
  'episodeEditor.errors.invalidBlockVoice':
    'قطعة واحدة أو أكثر لها صوت غير صالح. افتحوا منتقي الصوت لكل قطعة أو أعيدوا تحميل قائمة الأصوات.',
  'episodeEditor.errors.addTextFirst': 'أضيفوا نصًا قبل توليد الصوت.',
  'episodeEditor.errors.audioGenerationFailedApi':
    'تعذّر توليد الصوت. {{message}} (المدة المعروضة = تقدير.)',
  'episodeEditor.errors.audioGenerationFailed':
    'خطأ أثناء توليد الصوت. المدة المعروضة = تقدير.',
  'episodeEditor.success.published': 'تم نشر الحلقة!',
  'episodeEditor.success.draftSaved': 'تم حفظ المسودة',
  'episodeEditor.success.audioGenerated': 'تم توليد الصوت مع {{count}} قطعة',
  'episodeEditor.tabs.edit': 'تحرير',
  'episodeEditor.tabs.chapters': 'الفصول',
  'episodeEditor.tabs.voice': 'الصوت',
  'episodeEditor.tabs.podcasts': 'البودكاست',
  'episodeEditor.toolbar.undo': 'تراجع (Ctrl+Z)',
  'episodeEditor.toolbar.redo': 'إعادة (Ctrl+Y)',
  'episodeEditor.toolbar.generating': 'جارٍ التوليد…',
  'episodeEditor.toolbar.generateAudio': 'توليد الصوت',
  'episodeEditor.toolbar.save': 'حفظ',
  'episodeEditor.toolbar.publish': 'نشر',
  'episodeEditor.titlePlaceholder': 'عنوان الحلقة…',
  'episodeEditor.status.published': 'منشور',
  'episodeEditor.status.draft': 'مسودة',
  'episodeEditor.warnings.mistralNotConfigured':
    'يستخدم التعليق الصوتي للحلقات Mistral Voxtral TTS (نفس مفتاح الدورات). أضيفوا مفتاح Mistral في الإدارة ← تكاملات المنصة، ثم أعيدوا تحميل هذه الصفحة.',
  'episodeEditor.warnings.mistralNoVoices':
    'المفتاح معروف لدى الخادم لكن واجهة Mistral لم تُرجع أي صوت (خطأ API، حصة، شبكة). راجعوا سجلات الخادم ولوحة Mistral.',
  'episodeEditor.warnings.voiceLoadFailed':
    'تعذّر تحميل قائمة الأصوات (شبكة أو خادم). راجعوا إعداد Mistral في الإدارة ← تكاملات المنصة وسجلات الخادم.',
  'episodeEditor.warnings.voiceOffDisabled':
    'دون صوت فعلي، يبقى توليد التعليق الصوتي معطّلًا.',
  'episodeEditor.edit.voiceOff': 'التعليق الصوتي',
  'episodeEditor.edit.voiceDescription':
    'توليف عبر Mistral Voxtral TTS (تكاملات المنصة). اختاروا الصوت من تبويب «الصوت» أو لكل قطعة.',
  'episodeEditor.edit.coverImage': 'صورة الغلاف',
  'episodeEditor.edit.coverAlt': 'غلاف الحلقة',
  'episodeEditor.edit.deleteCover': 'حذف',
  'episodeEditor.edit.dropOrClickImage': 'انقروا أو أفلتوا صورة',
  'episodeEditor.edit.selectedVoice': 'الصوت المحدّد',
  'episodeEditor.edit.selectVoice': 'اختيار صوت',
  'episodeEditor.edit.lastAudioGenerated': 'آخر صوت مُولَّد',
  'episodeEditor.edit.audioNotFound': 'ملف الصوت غير موجود — أعيدوا توليد التعليق الصوتي.',
  'episodeEditor.edit.generatingInProgress': 'جارٍ التوليد…',
  'episodeEditor.edit.generateVoiceOff': 'توليد التعليق الصوتي',
  'episodeEditor.chapters.title': 'الفصول',
  'episodeEditor.chapters.add': 'إضافة',
  'episodeEditor.chapters.defaultChapterTitle': 'مقدمة',
  'episodeEditor.chapters.newChapterTitle': 'فصل {{n}}',
  'episodeEditor.chapters.blockCount': '{{count}} قطعة',
  'episodeEditor.voiceTab.availableVoices': 'الأصوات المتاحة',
  'episodeEditor.podcasts.linked': 'البودكاست المرتبطة',
  'episodeEditor.podcasts.assign': 'إسناد',
  'episodeEditor.podcasts.noneAvailable': 'لا بودكاست متاح',
  'episodeEditor.podcasts.close': 'إغلاق',
  'episodeEditor.podcasts.noneLinked': 'لا بودكاست مرتبطة',
  'episodeEditor.podcasts.assignHint': 'أسندوا هذه الحلقة إلى بودكاست واحد أو أكثر',
  'episodeEditor.podcasts.remove': 'إزالة',
  'episodeEditor.editor.addTextBlock': 'إضافة قطعة نصية',
  'episodeEditor.editor.scriptPlaceholder': 'ابدؤوا كتابة النص…',
  'episodeEditor.editor.addBlock': 'إضافة قطعة',
  'episodeEditor.player.loop': 'تكرار',
  'episodeEditor.player.playbackSpeed': 'سرعة التشغيل',
  'episodeEditor.player.collapse': 'طي',
  'episodeEditor.player.expand': 'توسيع',
  'episodeEditor.player.waveformHidden': 'الموجة الصوتية مخفية',

  // Training request panel
  'trainingRequest.panelTitle': 'طلب تدريب — محتوى تعليمي',
  'trainingRequest.intro': 'صِف الاحتياج. يوافق فريق الموارد البشرية على الطلب أو يرفضه؛ في حال الموافقة، ينتقل إلى إعداد المحتوى.',
  'trainingRequest.fieldTitle': 'عنوان التدريب',
  'trainingRequest.fieldDescription': 'وصف الاحتياج',
  'trainingRequest.fieldJustification': 'المبرّر / الأهداف',
  'trainingRequest.fieldDate': 'التاريخ المفضّل',
  'trainingRequest.datePlaceholder': 'مثال: الربع الثاني 2026',
  'trainingRequest.fieldFormateur': 'مدرّب المؤسسة',
  'trainingRequest.formateurPlaceholder': 'اختيار مدرّب…',
  'trainingRequest.formateursEmpty': 'لا يوجد حساب مدرّب مسجّل لمؤسستكم.',
  'trainingRequest.titleRequired': 'أدخل عنوانًا (حرفان على الأقل).',
  'trainingRequest.sent': 'تم تسجيل الطلب. ستتلقّون إشعارًا بالبريد الإلكتروني بالقرار.',
  'trainingRequest.sendError': 'تعذّر تسجيل الطلب. تحقّقوا من الاتصال أو الصلاحيات.',
  'trainingRequest.submit': 'إرسال الطلب',
  'common.cancel': 'إلغاء',
  'common.sending': 'جارٍ الإرسال…',
};
